import styled from '@emotion/styled';
import Button from 'components/atoms/Button';
import { colors } from 'theme/colors';

export const StyledButton = styled(Button)`
  &:focus {
    background-color: ${colors.white};
  }
`;
